import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "stats" }
const _hoisted_2 = { class: "stats__grid" }
const _hoisted_3 = { class: "stats__grid__card" }
const _hoisted_4 = { class: "stats__grid__card__content" }
const _hoisted_5 = { class: "stats__grid__card__title" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "stats__chart" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statCards, (statCard) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(statCard.value), 1),
          _createElementVNode("div", _hoisted_5, _toDisplayString(statCard.label), 1)
        ]))
      }), 256))
    ]),
    _hoisted_6
  ]))
}